<template lang="pug">
  v-dialog(v-model='dialog', max-width='1000')
    template(v-slot:activator='{ on, attrs }')
      v-fab-transition
        v-btn(
          v-if='wallet.is_can_spinwheel || dialog'
          v-bind='attrs'
          color='var(--bg-secondary-color)'
          fab
          dark
          x-large
          bottom
          right
          fixed
          v-on='on'
          style="z-index: 10;"
        )
          v-icon mdi-gift
    roulete(
      v-if='dialog'
      @close='close'
    )

</template>
<script> 
import Roulete from '../Roulete.vue'
export default {
  components:{
    Roulete
  },
  data: () => ({
    dialog:false,    
  }) ,
  computed: {
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
  },
  methods: {
    close () {
      this.dialog = false
    }
  }
} 
</script>